import cx from 'classnames'
import React, { forwardRef } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Button from '@material-ui/core/Button'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Paper from '@material-ui/core/Paper'
import { uniq } from 'libraries/lodash'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import Grid from '@material-ui/core/Grid'

const FilterBox = ({
  valueRef,
  expanded,
  setExpanded,
  multi,
  currentValueList,
  options,
  isShortcut,
  findNameFor,
  multiSuffix,
  shortcuts,
  title,
  shortcutsRef,
  dropdownRef,
  onChange
}) => (
  <div className='select-box relative'>
    <div
      className={cx('value flex items-center pointer', { selected: expanded })}
      ref={valueRef}
    >
      <FilterSelectButton {...{ expanded, setExpanded, multi, currentValueList, options, isShortcut, findNameFor, multiSuffix }} />
    </div>
    {expanded && options && (
      <FilterDropDown
        {...{ shortcuts, options, currentValueList, isShortcut, title, multi }}
        shortcutsRef={shortcutsRef}
        dropdownRef={dropdownRef}
        onChange={onChange}
      />
    )}
  </div>
)

export default FilterBox

const SelectButton = withStyles({
  root: {
    '&:hover': {
      backgroundColor: '#DFFCFF'
    }
  }
})(Button)

const FilterSelectButton = ({ expanded, setExpanded, ...props }) => (
  <SelectButton
    variant='contained'
    className='w-100 outline-0'
    classes={{ root: 'ttn ba bg-ghost-grey b--cadet-blue' }}
    onClick={() => setExpanded(!expanded)}
  >
    <div className='w-100 flex items-center justify-center cadet-blue'>
      <SelectedFilterValue {...{ expanded, ...props }} />
      {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
    </div>
  </SelectButton>
)

const SelectedFilterValue = ({ multi, currentValueList, expanded, options, findNameFor, multiSuffix, isShortcut }) => (
  <div className='mr6'>
    {multi
      ? currentValueList.length > 1
        ? (
          <span data-hover-popover-content={!expanded
            ? options
              .filter(o => currentValueList.indexOf(o.value) !== -1)
              .map(o => findNameFor(o.value))
              .join(', ')
            : undefined}
          >
            {`${currentValueList.length} ${multiSuffix}`}
          </span>
          )
        : currentValueList.map(value => isShortcut(value)
          ? findNameFor(value)
          : (
            <span key={value}>
              {findNameFor(value)}
            </span>
            )
        )
      : currentValueList.map(value => findNameFor(value) || ' ')}
  </div>
)

const FilterDropDown = ({ shortcuts, onChange, shortcutsRef, dropdownRef, ...props }) => (
  <Paper
    className='dropdown-container absolute top9 left0 z5 bg-white overflow-y-auto ph6 w-100'
    style={{ maxHeight: '20rem' }}
    elevation={4}
  >
    {shortcuts && <ShortCuts {...{ shortcuts, onChange, shortcutsRef }} />}
    <DropDownOptions {...{ ...props, onChange, dropdownRef }} />
  </Paper>
)

const ShortCuts = forwardRef(({ shortcuts, onChange }, shortcutsRef) => {
  const isButtonEvent = true

  return (
    <Grid
      container
      spacing={1}
      justify='space-between'
      ref={shortcutsRef}
      className='pt4 pb0 w-100'
    >
      {shortcuts.map(({ name, value }) => (
        <Grid item xs={12} sm={6} key={name} className='w-100'>
          <Button
            key={value}
            value={value}
            onClick={(e) => onChange(e, isButtonEvent)}
            classes={{ root: 'ttn w-100 ba', outlinedPrimary: 'teal', outlined: 'ph2' }}
            variant='outlined'
            color='primary'
          >
            {name}
          </Button>
        </Grid>
      ))}
    </Grid>
  )
})

const DropDownOptions = ({ options, currentValueList, isShortcut, title, multi, onChange, dropdownRef }) => (
  <div
    className='dropdown flex flex-column default-cursor mt3 mb4'
    ref={dropdownRef}
  >
    {options.map(({ name, value }, index) => (
      <OptionCheckBox key={index} {...{ currentValueList, isShortcut, title, name, value, multi, onChange }} />
    ))}
  </div>
)

const OptionCheckBox = ({ currentValueList, isShortcut, title, name, value, multi, onChange }) => {
  const selected = currentValueList.indexOf(value) !== -1
  const multiValue = value => selected
    ? uniq(currentValueList.filter(v => v !== value && !isShortcut(v))).join(',')
    : uniq(currentValueList.concat(value).filter(v => !isShortcut(v))).join(',')

  return (
    <FormControlLabel
      classes={{ root: 'default-cursor' }}
      control={
        <Checkbox
          id={title + value}
          value={multi ? multiValue(value) : value}
          checked={selected}
          onChange={onChange}
          size='small'
          classes={{ root: 'pa2' }}
        />
      }
      label={
        <span className='f6'>
          {name}
        </span>
      }
    />
  )
}
